function LoadingSpinner({ size = 'default', className = '' }) {
  const sizeStyle = size === 'large' ? { width: 40, height: 40 } :
                    size === 'small' ? { width: 16, height: 16 } :
                    { width: 24, height: 24 }

  return (
    <div className={`spinner ${className}`} style={sizeStyle} />
  )
}

function LoadingOverlay({ message = '' }) {
  return (
    <div className="loading-overlay">
      <div style={{ textAlign: 'center' }}>
        <LoadingSpinner size="large" />
        {message && <p className="mt-4 text-muted">{message}</p>}
      </div>
    </div>
  )
}

LoadingSpinner.Overlay = LoadingOverlay

export default LoadingSpinner
